import * as React from 'react';
import { Box, Typography, Button } from '@mui/material';
import useSetState from '../../modules/hooks/useSetState';
import i18n from '../../i18n';
import './scss/reserve-meal-period.scss';
import ResrvePeroidCard from './reserve-period-card.component';
import { ReserveMealPeriodCardsSkeleton } from './reserve-meal-period-cards-skeleton.component';
import { Add } from '@mui/icons-material';

import { apiManage_rbp } from '../../request';
import { ReservePeriod, ReserveTime } from '../../models/reserve.entity';
import { getDate } from '../../constants/utils';
import { uniqueId } from 'lodash';
import _ from 'lodash';
import GlobalNotification from '../../component/common/snackbar';
import BaseInput from '../../component/form/base-input.component';

import moment, { Moment } from 'moment';
import setLoading from '../../component/linear-determinate';
import ButtonComponent from '../../component/button/button.component';
import AlertDialog from '../../component/dialog/alert-dialog.component';

function ResrveMealPeriodPage() {

    const emptyMetaData: Array<ReserveTime> = [
        { week: 1, childrens: [] },
        { week: 2, childrens: [] },
        { week: 3, childrens: [] },
        { week: 4, childrens: [] },
        { week: 5, childrens: [] },
        { week: 6, childrens: [] },
        { week: 0, childrens: [] },
    ]

    const deleteIds = React.useRef<number[]>([]);

    const [state, setState] = useSetState<State>({
        metaData: emptyMetaData,
        selectedIndex: 0,
        curWeekMetaData: emptyMetaData[0],
        peopleNum: 0,
        /** 预约时段接口返回后再展示餐期卡片，首屏用骨架屏 */
        isReserveHourReady: false,
        alertParam: {
            open: false,
        },
    })

    const { metaData, selectedIndex, curWeekMetaData, peopleNum, alertParam, isReserveHourReady } = state;

    React.useEffect(() => {
        let cancelled = false;
        (async () => {
            setLoading(true);
            await init(true);
            if (!cancelled) {
                setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [])

    const init = async (init?: boolean) => {
        try {
            const [peopleNum, hours] = await Promise.all([getSetting101(), apiManage_rbp.get_reserve_hour()])
            if (!hours?.error) {
                setState({
                    metaData: hours,
                    curWeekMetaData: hours[init ? 0 : selectedIndex],
                    selectedIndex: init ? 0 : selectedIndex,
                    peopleNum,
                })
            }
        } finally {
            setState({ isReserveHourReady: true })
        }
    }

    /**
     * 添加餐期
     */
    const onAddPeroid = (weekData: ReserveTime, dataIndex: number) => {
        const _metaData = _.cloneDeep(metaData);
        const newPeroid = {
            id: -1, // 餐期id
            name: '', // 餐期名称
            date: [],
            code: uniqueId(`${weekData.week}-`),
        };
        weekData.childrens.unshift(newPeroid);
        _.set(_metaData, `[${dataIndex}]`, weekData);
        setState({
            metaData: [..._metaData],
            curWeekMetaData: _metaData[selectedIndex],
        });
        const anchorId = `reserve-period-card-${newPeroid.code}`;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                document.getElementById(anchorId)?.scrollIntoView({ behavior: 'auto', block: 'start' });
            });
        });
    }

    /**
     * 删除餐期
     */
    const onDeletePeriod = async (weekData: ReserveTime, dataIndex: number, periodIndex: number) => {
        const _metaData = _.cloneDeep(metaData);
        const period = weekData.childrens[periodIndex];
        if (period.id !== -1) {
            // const result = await apiManage_rbp.delete_reserve_hour([period.id]);
            deleteIds.current.push(period.id);
        }
        weekData.childrens.splice(periodIndex, 1);
        _.set(_metaData, `[${dataIndex}]`, weekData);
        console.log(_metaData, 'onDeletePeriod')
        setState({
            metaData: _metaData,
            curWeekMetaData: _metaData[selectedIndex],
        })
    }

    /**
     * 更改餐期名称
     * @param weekData
     * @param dataIndex
     * @param periodIndex
     * @param value
     */
    const onChangePeriodName = (weekData: ReserveTime, dataIndex: number, periodIndex: number, value: string) => {
        const _metaData = _.cloneDeep(metaData);
        weekData.childrens[periodIndex].name = value;
        _.set(_metaData, `[${dataIndex}]`, weekData);
        setState({
            metaData: _metaData,
            curWeekMetaData: _metaData[selectedIndex],
        })
    }

    /**
     * 新增餐期间时间段
     */
    const onAddPeroidTimeTab = (
        weekData: ReserveTime,
        dataIndex: number,
        periodIndex: number,
        newTab: { start_time: string, end_time: string }
    ) => {
        const dateList: any[] = [];
        weekData.childrens.forEach(item => {
            dateList.push(...item.date)
        })
        const { start_time: newStartStr, end_time: newEndStr } = newTab;
        const newStart = moment(newStartStr, 'HH:mm');
        const newEnd = moment(newEndStr, 'HH:mm');
        if (newStart.isSame(newEnd)) {
            GlobalNotification.error(i18n.t('reserve_meal_page_time_no_overlap_or_end_bigger_start'));
            return;
        }
        const isOverlap = dateList.some((date) => {
            const startTime = moment(date.start_time, 'HH:mm');
            const endTime = moment(date.end_time, 'HH:mm');
            return (
                newStart.isSame(startTime) ||
                newEnd.isSame(endTime) ||
                newStart.isBetween(startTime, endTime) ||
                newEnd.isBetween(startTime, endTime) ||
                startTime.isBetween(newStart, newEnd) ||
                endTime.isBetween(newStart, newEnd)
            );
        });
        if (isOverlap) {
            GlobalNotification.error(i18n.t('reserve_meal_page_time_no_overlap_or_end_bigger_start'));
            return;
        }
        const _metaData = _.cloneDeep(metaData);
        // 新增参数
        const dateItem = {
            time_id: -1,
            ...newTab,
        };
        const period = weekData.childrens[periodIndex];
        if (period.id > -1) {
            _.set(dateItem, 'parent_topic_id', period.id);
        } else {
            _.set(dateItem, 'code', period?.code ?? `${weekData.week}`);
        }
        weekData.childrens[periodIndex]?.date.push(dateItem)
        _.set(_metaData, `[${dataIndex}]`, weekData);
        console.log(_metaData, 'onAddPeroidTimeTab')
        setState({
            metaData: [..._metaData],
            curWeekMetaData: _metaData[selectedIndex],
        })
    }

    /**
     * 删除餐期时间段
     */
    const onDeletePeroidTimeTab = (
        weekData: ReserveTime,
        dataIndex: number,
        periodIndex: number,
        period: ReservePeriod,
        tid: number
    ) => {
        const _metaData = _.cloneDeep(metaData);
        weekData.childrens[periodIndex] = period;
        _.set(_metaData, `[${dataIndex}]`, weekData);
        console.log(_metaData, 'onDeletePeroidTimeTab');
        if (tid > -1) deleteIds.current.push(tid);
        setState({
            metaData: _metaData,
            curWeekMetaData: _metaData[selectedIndex],
        })
    }

    /**
     * 保存操作
     */
    const onSave = async (data?: ReserveTime[]) => {
        setLoading(true);
        const newMetaData = data || metaData;

        const result = await apiManage_rbp.post_reserve_hour(newMetaData, deleteIds.current);
        if (!result.error) {
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            deleteIds.current = [];
            await init();
            setLoading(false);
        }
        else {
            setLoading(false);
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }
    }
    /**
     * 关闭同步弹窗
     */
    const closeAlert = () => {
        setState({
            alertParam: {
                open: false,
                desc: '',
                title: '',
            }
        })
    }

    /**
     * 打开同步弹窗
     */
    const openAlert = (period: ReservePeriod) => {
        setState({
            alertParam: {
                open: true,
                title: i18n.t('reserve_meal_page_time_async_to_other_day'),
                desc: i18n.t('reserve_meal_page_time_if_async_this_to_other'),
                onCancel: closeAlert,
                onConfirm: () => checkBeforeAsync(period)
            },
        })
    }

    /**
     * 时间段校验
     */
    const checkTimeinDay = (newStart: Moment, newEnd: Moment, currentDay: ReserveTime) => {
        const errorInfo: {
            isError: boolean,
            ids: number[],
            msg: string,
        } = {
            isError: false,
            ids: [],
            msg: '',
        }
        const errorList: string[] = [];
        currentDay.childrens.forEach(period => {
            const isOverlap = period.date.some((date) => {
                const startTime = moment(date.start_time, 'HH:mm');
                const endTime = moment(date.end_time, 'HH:mm');
                return (
                    newStart.isSame(startTime) ||
                    newEnd.isSame(endTime) ||
                    newStart.isBetween(startTime, endTime) ||
                    newEnd.isBetween(startTime, endTime) ||
                    startTime.isBetween(newStart, newEnd) ||
                    endTime.isBetween(newStart, newEnd)
                );
            });
            if (isOverlap) {
                _.set(period, 'showDelete', true)
                errorList.push(period.name || ` `)
                period.id !== -1 && errorInfo.ids.push(period.id)
            }
        })
        if (errorList.length) {
            const msg = `${getDate(currentDay.week ?? 1)}---"${errorList.join('、')}"`;
            errorInfo.isError = true;
            errorInfo.msg = msg;
        }

        return errorInfo
    }

    /**
     * 校验该餐期是否与其它日期冲突
     */
    const checkBeforeAsync = (period: ReservePeriod) => {
        const newData = _.cloneDeep(metaData);
        // newData.splice(selectedIndex, 1)
        const errorInfo: {
            isError: boolean,
            errorName: string,
            errorList: string[],
            errorId: number[],
        }[] = [];
        period?.date.forEach(currentDate => {
            const newStart = moment(currentDate.start_time, 'HH:mm');
            const newEnd = moment(currentDate.end_time, 'HH:mm');
            const errorList: string[] = [];
            const errorId: number[] = [];
            newData.forEach((day, index) => {
                if (index !== selectedIndex) {
                    const res = checkTimeinDay(newStart, newEnd, day);
                    if (res.isError) {
                        errorList.push(res.msg)
                        errorId.push(...res.ids)
                    }
                }
            })
            if (errorList.length > 0) {
                errorInfo.push({
                    isError: true,
                    errorName: `${currentDate.start_time} - ${currentDate.end_time}`,
                    errorList,
                    errorId
                })
            }
        })
        if (errorInfo.length > 0) {
            console.log('newData', newData)
            const ids: number[] = Array.from(new Set(errorInfo.map(error => error.errorId).flat()))
            setState({
                alertParam: {
                    open: true,
                    title: i18n.t('reserve_meal_page_time_has_error'),
                    size: 'md',
                    onCancel: closeAlert,
                    onConfirm: () => asyncTime(period, newData, ids),
                    customContent: renderCustomContent(errorInfo)
                }
            })
        } else {
            asyncTime(period)
        }
    }

    /**
     * 弹窗-内容
     */
    const renderCustomContent = (errorInfo: {
        isError: boolean;
        errorName: string;
        errorList: string[];
    }[]) => {
        return (
            <Box>
                <p style={{ fontWeight: 'bold', fontSize: 22, marginBottom: 15 }}>{i18n.t('reserve_meal_page_time_if_delete_other_time')}</p>
                {
                    errorInfo.map((item, i) => {
                        const msg = `${item.errorName} : ${item.errorList.join(';  ')}`;
                        return <p key={`${i}`}>{msg}</p>
                    })
                }
            </Box>
        )
    }

    /**
     * 同步餐期
     */
    const asyncTime = async (period: ReservePeriod, newData?: ReserveTime[], errorIds?: number[]) => {
        console.log('强制同步', period)
        const newMetaData = _.cloneDeep(newData || metaData)
        newMetaData.forEach((item, index) => {
            if (index !== selectedIndex) {
                const newItem = item.childrens.filter(date => !_.get(date, 'showDelete'));
                const code = uniqueId(`${item.week}-`);
                const newPeriod: ReservePeriod = {
                    id: -1,
                    code,
                    name: period.name,
                    date: period.date.map(date => ({
                        code,
                        time_id: -1,
                        start_time: date.start_time,
                        end_time: date.end_time
                    }))
                }
                newItem.push(newPeriod)
                item.childrens = newItem
            }
        })
        console.log('后来的newData', newMetaData)
        errorIds && deleteIds.current.push(...errorIds);
        setState({
            alertParam: {
                open: false,
                desc: '',
                title: '',
            }
        })
        await onSave(newMetaData);
    }

    const onSetCurWeekData = (index: number) => {
        const _curWeekMetaData = metaData[index];
        setState({
            curWeekMetaData: _curWeekMetaData,
            selectedIndex: index,
        })
    }

    /**
     * 获取设置表101
     */
    const getSetting101 = async () => {
        const result = await apiManage_rbp.getSettingById(101);
        if (!_.get(result, 'error')) {
            return _.get(result, '[0].value', 0)
        } else {
            GlobalNotification.error('fail: getSetting101')
        }
        return 0
    }

    /**
     * 修改设置表101（桌台分配人数浮动值）
     * @returns 是否保存成功
     */
    const onSaveSetting = async (): Promise<boolean> => {
        setLoading(true);
        const result = await apiManage_rbp.patchSettingById(101, { stringValue: String(Number(peopleNum)) });
        if (!result.error) {
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            setLoading(false);
            return true;
        }
        GlobalNotification.error(i18n.t('global_text_operate_failure'));
        setLoading(false);
        return false;
    };

    /** 先保存设置 101，成功后再保存预约时段 */
    const onSaveAll = async () => {
        const ok = await onSaveSetting();
        if (!ok) {
            return;
        }
        await onSave();
    };

    return (
        <>
            <Box className='reserve-meal-period-page'>
                <Box className='reserve-meal-period-page__shell'>
                    <Box className='reserve-meal-period-page__title-row'>
                        <Typography component='h2' className='reserve-meal-period-page__main-title'>
                            {i18n.t('reserve_meal_reservation_config')}
                        </Typography>
                        <Box className='reserve-meal-period-page__title-actions'>
                            <ButtonComponent action='SAVE' handleClick={onSaveAll} disabled={!isReserveHourReady} />
                        </Box>
                    </Box>

                    <Box className='reserve-meal-period-page__subheader'>
                        <Typography component='h3' className='reserve-meal-period-page__section-heading'>
                            {i18n.t('reserve_meal_page_optional_time_slots')}
                        </Typography>
                        <Box className='reserve-meal-period-page__people-inline'>
                            <Typography className='reserve-meal-period-page__people-desc'>
                                {i18n.t('reserve_meal_page_table_people_num_desc')}
                            </Typography>
                            <Box>
                                <BaseInput
                                    type='number'
                                    variant='outlined'
                                    hiddenLabel
                                    size='small'
                                    className='reserve-meal-period-page__people-input'
                                    value={peopleNum}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        const value = Number(Number(event.currentTarget.value).toFixed(0));
                                        if (value >= 0) {
                                            setState({ peopleNum: value });
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>

                    <Box className='reserve-meal-period-page__week-tabs' role='tablist' aria-label={i18n.t('reserve_meal_page_select_time_setting')}>
                        {metaData.map((item, index) => (
                            <Button
                                key={index}
                                type='button'
                                disableRipple
                                className={[
                                    'reserve-meal-period-page__week-tab',
                                    selectedIndex === index ? 'reserve-meal-period-page__week-tab--active' : '',
                                ]
                                    .filter(Boolean)
                                    .join(' ')}
                                onClick={() => onSetCurWeekData(index)}
                            >
                                {getDate(item.week)}
                            </Button>
                        ))}
                    </Box>

                    <Box className='reserve-meal-period-page__cards' aria-busy={!isReserveHourReady}>
                        {!isReserveHourReady ? (
                            <ReserveMealPeriodCardsSkeleton count={3} />
                        ) : (
                            (curWeekMetaData.childrens || []).map((period, periodIndex) => (
                                <ResrvePeroidCard
                                    key={`card-${period.id}-${period.code}-${periodIndex}`}
                                    period={period}
                                    onDeletePeriod={() => onDeletePeriod(curWeekMetaData, selectedIndex, periodIndex)}
                                    onAddPeroidTimeTab={(newTab: { start_time: string; end_time: string }) =>
                                        onAddPeroidTimeTab(curWeekMetaData, selectedIndex, periodIndex, newTab)
                                    }
                                    onChangePeriodName={(value: string) => onChangePeriodName(curWeekMetaData, selectedIndex, periodIndex, value)}
                                    onDeletePeroidTimeTab={(p: ReservePeriod, tid: number) =>
                                        onDeletePeroidTimeTab(curWeekMetaData, selectedIndex, periodIndex, p, tid)
                                    }
                                    asyncPeroidTime={() => openAlert(period)}
                                />
                            ))
                        )}
                    </Box>

                    <Button
                        type='button'
                        variant='outlined'
                        className='reserve-meal-period-page__add-period-bottom'
                        disabled={!isReserveHourReady}
                        onClick={() => onAddPeroid(curWeekMetaData, selectedIndex)}
                        startIcon={<Add />}
                    >
                        {i18n.t('reserve_meal_page_add_order_time')}
                    </Button>
                </Box>

                {alertParam.open && (
                    <AlertDialog
                        open={alertParam.open}
                        title={alertParam.title || ''}
                        desc={alertParam.desc}
                        onCancel={alertParam.onCancel || (() => { })}
                        onConfirm={alertParam.onConfirm || (() => { })}
                        size={alertParam.size}
                        customContent={alertParam.customContent}
                    />
                )}
            </Box>
        </>
    );
}

export default ResrveMealPeriodPage


type State = {
    metaData: Array<ReserveTime>;
    curWeekMetaData: ReserveTime;
    selectedIndex: number;
    peopleNum: number;
    /** get_reserve_hour 已返回（成功或失败），可展示餐区内容 */
    isReserveHourReady: boolean;
    alertParam: {
        open: boolean,
        title?: string,
        desc?: string,
        size?: 'lg' | 'md' | 'sm' | 'xl' | 'xs' | undefined,
        onCancel?: () => void,
        onConfirm?: () => void,
        customContent?: JSX.Element
    };
}